/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApprovalRequestCompetence } from './ApprovalRequestCompetence';
import {
    ApprovalRequestCompetenceFromJSON,
    ApprovalRequestCompetenceFromJSONTyped,
    ApprovalRequestCompetenceToJSON,
} from './ApprovalRequestCompetence';
import type { ApprovalRequestFile } from './ApprovalRequestFile';
import {
    ApprovalRequestFileFromJSON,
    ApprovalRequestFileFromJSONTyped,
    ApprovalRequestFileToJSON,
} from './ApprovalRequestFile';
import type { ApprovalRequestUser } from './ApprovalRequestUser';
import {
    ApprovalRequestUserFromJSON,
    ApprovalRequestUserFromJSONTyped,
    ApprovalRequestUserToJSON,
} from './ApprovalRequestUser';
import type { ExternalCertificate } from './ExternalCertificate';
import {
    ExternalCertificateFromJSON,
    ExternalCertificateFromJSONTyped,
    ExternalCertificateToJSON,
} from './ExternalCertificate';
import type { LearningRequest } from './LearningRequest';
import {
    LearningRequestFromJSON,
    LearningRequestFromJSONTyped,
    LearningRequestToJSON,
} from './LearningRequest';

/**
 * Updates an approval request. For request_type=course_completion, any editable field can be changed at any time. For request_course and request_topic, only records still in status=draft can be updated - once approved or rejected, the record is locked and update returns a 400. Any active manager or owner in the company space can edit a draft learning request, even when the requester is outside the actor's user management scope. Editable fields are subject_title, subject_content, subject_provider, price, subject_date, subject_end_date, subject_start_time, subject_end_time, subject_location, reason, note, competences and attachment_file_ids. A thematic request may gain a concrete solution, but remains request_type=request_topic. user_id and request_type are immutable and rejected if passed; status remains draft. Updating does not send an email. Approval later requires subject_title, subject_date, subject_provider, price, and at least one competence with a level.
 * @export
 * @interface ApprovalRequestUpdateResponse
 */
export interface ApprovalRequestUpdateResponse {
    /**
     * 
     * @type {number}
     * @memberof ApprovalRequestUpdateResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestUpdateResponse
     */
    request_type: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestUpdateResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestUpdateResponse
     */
    subject_title: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApprovalRequestUpdateResponse
     */
    subject_date: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ApprovalRequestUpdateResponse
     */
    subject_end_date: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestUpdateResponse
     */
    subject_start_time: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestUpdateResponse
     */
    subject_end_time: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestUpdateResponse
     */
    subject_location: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestUpdateResponse
     */
    subject_provider: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestUpdateResponse
     */
    subject_content: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestUpdateResponse
     */
    study_time: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestUpdateResponse
     */
    form: string | null;
    /**
     * 
     * @type {number}
     * @memberof ApprovalRequestUpdateResponse
     */
    price: number | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestUpdateResponse
     */
    reason: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestUpdateResponse
     */
    rejection_reason: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovalRequestUpdateResponse
     */
    note: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ApprovalRequestUpdateResponse
     */
    submitted_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApprovalRequestUpdateResponse
     */
    created_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApprovalRequestUpdateResponse
     */
    updated_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApprovalRequestUpdateResponse
     */
    approved_at: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ApprovalRequestUpdateResponse
     */
    decided_at: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApprovalRequestUpdateResponse
     */
    realization_complete: boolean | null;
    /**
     * 
     * @type {ApprovalRequestUser}
     * @memberof ApprovalRequestUpdateResponse
     */
    user?: ApprovalRequestUser;
    /**
     * 
     * @type {ApprovalRequestUser}
     * @memberof ApprovalRequestUpdateResponse
     */
    created_by?: ApprovalRequestUser;
    /**
     * 
     * @type {ApprovalRequestUser}
     * @memberof ApprovalRequestUpdateResponse
     */
    decided_by?: ApprovalRequestUser;
    /**
     * 
     * @type {ApprovalRequestFile}
     * @memberof ApprovalRequestUpdateResponse
     */
    certificate?: ApprovalRequestFile;
    /**
     * 
     * @type {Array<ApprovalRequestFile>}
     * @memberof ApprovalRequestUpdateResponse
     */
    attachments?: Array<ApprovalRequestFile>;
    /**
     * 
     * @type {LearningRequest}
     * @memberof ApprovalRequestUpdateResponse
     */
    learning_request?: LearningRequest;
    /**
     * 
     * @type {ExternalCertificate}
     * @memberof ApprovalRequestUpdateResponse
     */
    external_certificate?: ExternalCertificate;
    /**
     * 
     * @type {Array<ApprovalRequestCompetence>}
     * @memberof ApprovalRequestUpdateResponse
     */
    competences?: Array<ApprovalRequestCompetence>;
}

/**
 * Check if a given object implements the ApprovalRequestUpdateResponse interface.
 */
export function instanceOfApprovalRequestUpdateResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "request_type" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "subject_title" in value;
    isInstance = isInstance && "subject_date" in value;
    isInstance = isInstance && "subject_end_date" in value;
    isInstance = isInstance && "subject_start_time" in value;
    isInstance = isInstance && "subject_end_time" in value;
    isInstance = isInstance && "subject_location" in value;
    isInstance = isInstance && "subject_provider" in value;
    isInstance = isInstance && "subject_content" in value;
    isInstance = isInstance && "study_time" in value;
    isInstance = isInstance && "form" in value;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "rejection_reason" in value;
    isInstance = isInstance && "note" in value;
    isInstance = isInstance && "submitted_at" in value;
    isInstance = isInstance && "created_at" in value;
    isInstance = isInstance && "updated_at" in value;
    isInstance = isInstance && "approved_at" in value;
    isInstance = isInstance && "decided_at" in value;
    isInstance = isInstance && "realization_complete" in value;

    return isInstance;
}

export function ApprovalRequestUpdateResponseFromJSON(json: any): ApprovalRequestUpdateResponse {
    return ApprovalRequestUpdateResponseFromJSONTyped(json, false);
}

export function ApprovalRequestUpdateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprovalRequestUpdateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'request_type': json['request_type'],
        'status': json['status'],
        'subject_title': json['subject_title'],
        'subject_date': (json['subject_date'] === null ? null : new Date(json['subject_date'])),
        'subject_end_date': (json['subject_end_date'] === null ? null : new Date(json['subject_end_date'])),
        'subject_start_time': json['subject_start_time'],
        'subject_end_time': json['subject_end_time'],
        'subject_location': json['subject_location'],
        'subject_provider': json['subject_provider'],
        'subject_content': json['subject_content'],
        'study_time': json['study_time'],
        'form': json['form'],
        'price': json['price'],
        'reason': json['reason'],
        'rejection_reason': json['rejection_reason'],
        'note': json['note'],
        'submitted_at': (new Date(json['submitted_at'])),
        'created_at': (new Date(json['created_at'])),
        'updated_at': (new Date(json['updated_at'])),
        'approved_at': (json['approved_at'] === null ? null : new Date(json['approved_at'])),
        'decided_at': (json['decided_at'] === null ? null : new Date(json['decided_at'])),
        'realization_complete': json['realization_complete'],
        'user': !exists(json, 'user') ? undefined : ApprovalRequestUserFromJSON(json['user']),
        'created_by': !exists(json, 'created_by') ? undefined : ApprovalRequestUserFromJSON(json['created_by']),
        'decided_by': !exists(json, 'decided_by') ? undefined : ApprovalRequestUserFromJSON(json['decided_by']),
        'certificate': !exists(json, 'certificate') ? undefined : ApprovalRequestFileFromJSON(json['certificate']),
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(ApprovalRequestFileFromJSON)),
        'learning_request': !exists(json, 'learning_request') ? undefined : LearningRequestFromJSON(json['learning_request']),
        'external_certificate': !exists(json, 'external_certificate') ? undefined : ExternalCertificateFromJSON(json['external_certificate']),
        'competences': !exists(json, 'competences') ? undefined : ((json['competences'] as Array<any>).map(ApprovalRequestCompetenceFromJSON)),
    };
}

export function ApprovalRequestUpdateResponseToJSON(value?: ApprovalRequestUpdateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'request_type': value.request_type,
        'status': value.status,
        'subject_title': value.subject_title,
        'subject_date': (value.subject_date === null ? null : value.subject_date.toISOString().substr(0,10)),
        'subject_end_date': (value.subject_end_date === null ? null : value.subject_end_date.toISOString().substr(0,10)),
        'subject_start_time': value.subject_start_time,
        'subject_end_time': value.subject_end_time,
        'subject_location': value.subject_location,
        'subject_provider': value.subject_provider,
        'subject_content': value.subject_content,
        'study_time': value.study_time,
        'form': value.form,
        'price': value.price,
        'reason': value.reason,
        'rejection_reason': value.rejection_reason,
        'note': value.note,
        'submitted_at': (value.submitted_at.toISOString()),
        'created_at': (value.created_at.toISOString()),
        'updated_at': (value.updated_at.toISOString()),
        'approved_at': (value.approved_at === null ? null : value.approved_at.toISOString()),
        'decided_at': (value.decided_at === null ? null : value.decided_at.toISOString()),
        'realization_complete': value.realization_complete,
        'user': ApprovalRequestUserToJSON(value.user),
        'created_by': ApprovalRequestUserToJSON(value.created_by),
        'decided_by': ApprovalRequestUserToJSON(value.decided_by),
        'certificate': ApprovalRequestFileToJSON(value.certificate),
        'attachments': value.attachments === undefined ? undefined : ((value.attachments as Array<any>).map(ApprovalRequestFileToJSON)),
        'learning_request': LearningRequestToJSON(value.learning_request),
        'external_certificate': ExternalCertificateToJSON(value.external_certificate),
        'competences': value.competences === undefined ? undefined : ((value.competences as Array<any>).map(ApprovalRequestCompetenceToJSON)),
    };
}

